import classNames from "classnames";
import { useDuck } from "duck/ui/chat/contexts/DuckContext";
import Box from "@mui/material/Box";

import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";
import ChatMessages from "./ChatMessages";
import { ResizeHandle } from "./components/ResizeHandle";
import { useDuckSidebarResizeContext } from "./contexts/useDuckSidebarResizeContext";

interface Props {
  fullScreen?: boolean;
}

const ChatContainer = ({ fullScreen = false }: Props) => {
  const { open } = useDuck();
  const { resizing, sidebarWidth, onMouseDown } = useDuckSidebarResizeContext();

  return (
    <div
      className={classNames("bg-white border-l border-gray-100", {
        "flex-1 min-w-0": fullScreen,
        "min-w-[400px] max-w-[800px]": !fullScreen,
        hidden: !fullScreen && !open,
      })}
      style={
        fullScreen
          ? undefined
          : {
              width: sidebarWidth,
              transition: resizing.current ? "none" : "width 0.2s",
            }
      }
    >
      <Box className="h-full flex flex-col relative">
        {!fullScreen && <ResizeHandle onMouseDown={onMouseDown} />}
        <ChatHeader />
        <ChatMessages />
        <ChatInput />
      </Box>
    </div>
  );
};

export default ChatContainer;
